'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vetForm = require('./vet-form.html');

var _vetForm2 = _interopRequireDefault(_vetForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _vetForm2.default,
  bindings: {
    adverseEvent: '<',
    states: '<',
    locked: '<'
  },
  controller: function () {
    function VetFormComponent() {
      'ngInject';

      _classCallCheck(this, VetFormComponent);
    }

    _createClass(VetFormComponent, [{
      key: 'hasValidContact',
      value: function hasValidContact(adverseEvent) {
        var validOwner = adverseEvent.OwnerPerson && adverseEvent.OwnerPerson.FirstName && adverseEvent.OwnerPerson.LastName && adverseEvent.OwnerPerson.HomePhone;

        return validOwner;
      }
    }]);

    return VetFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/adverse-event/vet-form/vet-form.component.js